// 计费分类管理

import { HttpCusbillTemplateList, HttOperaTemplateOne } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
// import { mapGetters } from 'vuex';
import comSetCode from './setcode'

export default {
    mixins: [TableList],
    components: {
        comSetCode
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_type: '1',
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpCusbillTemplateList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            const temptype = this.formData.search.EQ_type;
            switch (type) {
                case 'add':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "添加模板",
                        width: 460,
                        component: "comSetCode",
                        temptype: temptype,
                        showFooter: false,
                    };
                    break;
                case 'edit':
                    sessionStorage.setItem('billtemplate', JSON.stringify(params))
                    this.$router.push({
                        name: 'costbillingRateTemplateupdate',
                        params: { type: "edit" },
                        query: { id: params.id, temptype: temptype },
                    });
                    break;
                case 'failure':
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params, status: 1 },
                        title: "失效操作",
                        ajaxRequest: HttOperaTemplateOne
                    }
                    break;
                case 'active':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params, status: 0 },
                        title: "激活操作",
                        ajaxRequest: HttOperaTemplateOne
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, status } = row;
            return [{
                label: '编辑',
                show: true,
                params: row,
                operate: 'edit'
            }, {
                label: '失效',
                show: status == 0,
                params: id,
                operate: 'failure'
            },
            {
                label: '激活',
                show: status == 1,
                params: id,
                operate: 'active'
            },
            ]
        },
    },
    computed: {
        // ...mapGetters('dictionary', ['getSysorgList']),
        TabsData() {
            return [
                {
                    name: "仓库作业费",
                    key: 'EQ_type',
                    val: '1'
                }, {
                    name: "仓储费",
                    key: 'EQ_type',
                    val: '4'
                }, {
                    name: "包材费",
                    key: 'EQ_type',
                    val: '5'
                }, {
                    name: "增值服务费",
                    key: "EQ_type",
                    val: '3'
                }
            ]
        },
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "模板Code",
                    key: 'CN_code',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "模板名称",
                    key: 'CN_name',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "状态",
                    key: 'EQ_status',
                    show: true,
                    tag: 'vSelect',
                    options: [
                        { value: 0, label: '有效' },
                        { value: 1, label: '无效' },
                    ],
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: '模板Code',
                    key: 'code',
                }, {
                    title: '模板名称',
                    key: 'name',
                }, {
                    title: '计费币种',
                    key: 'currency',
                }, {
                    title: '状态',
                    key: 'status',
                    render: (h, { row }) => row.status == 1 ? '无效' : '有效',
                }, {
                    title: '备注',
                    key: 'remark',
                }, {
                    title: '更新时间',
                    key: 'createdAt',
                }];
        },
    },
};




